import { BrowserRouter, Routes, Route } from 'react-router';
import { MapView } from './pages/MapView';
import { TableView } from './pages/TableView';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MapView />} />
        <Route path="/table" element={<TableView />} />
      </Routes>
    </BrowserRouter>
  );
}
